import { render } from "./ResourcesSection.vue?vue&type=template&id=f350b432"
import script from "./ResourcesSection.vue?vue&type=script&lang=js"
export * from "./ResourcesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__